import React from 'react'
// components
import AvatarUpload from '../AvatarUpload'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionOrigin from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import {
  ReduxInput,
  ReduxSelect,
  ReduxSwitch,
  ReduxDatePicker,
  ReduxGeosuggest
} from 'components/FormElements/ReduxForm'
// constants
import { LANGUAGE_OPTIONS } from 'constants/countries'
import { USER_GENDER_OPTIONS } from 'constants/users'
// themes
import { colors } from 'themes/index'
// views
import { BottomSection, PhonesSection, TopSection, TopSectionFields } from '../../views'
// utils
import { email, required } from 'utils/validators'
import { generateTimezoneOptions } from 'utils/date'

export const PANEL_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 24px 36px 24px',
  gap: 16
} as React.CSSProperties

const UserData: React.FC<any> = ({ avatar, onAvatarUpload }) => {
  return (
    <AccordionOrigin defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>User data</AccordionSummary>
      <AccordionDetails style={PANEL_STYLES}>
        <TopSection>
          <TopSectionFields>
            <ReduxSwitch name='active' label='Active' />
            <ReduxInput name='firstName' label='First Name' validate={[required]} />
            <ReduxInput name='middleName' label='Middle Name' />
            <ReduxInput name='lastName' label='Surname' validate={[required]} />
            <ReduxInput name='displayName' label='Display Name' />
            <ReduxDatePicker name='dateOfBirth' label='Date of Birth' />
          </TopSectionFields>
          <AvatarUpload
            avatar={avatar}
            onUpload={onAvatarUpload}
            description='Change your profile picture'
          />
        </TopSection>

        <BottomSection>
          <ReduxSelect label='Gender' name='gender' options={USER_GENDER_OPTIONS} />
          <ReduxGeosuggest label='Address' name='address' />
          <ReduxSelect label='Preferred Language' name='language' options={LANGUAGE_OPTIONS} />
          <ReduxSelect label='Time Zone' name='timezone' options={generateTimezoneOptions()} />
          <PhonesSection>
            <ReduxInput label='Home Phone' name='homePhone' />
            <ReduxInput label='Mobile Phone' name='mobilePhone' />
            <ReduxInput label='Work Phone' name='workPhone' />
          </PhonesSection>
          <ReduxInput label='Email' name='email' type='email' validate={[email, required]} />
          <ReduxInput label='Alternate Email' type='email' name='alternateEmail' />
        </BottomSection>
      </AccordionDetails>
    </AccordionOrigin>
  )
}

export default UserData
